import {
  GraphQLInputObjectType,
  GraphQLNonNull,
  GraphQLID,
  GraphQLList,
  GraphQLBoolean
} from 'graphql'

export interface ServerDeleteMutationArgs {
  readonly input?: {
    readonly organizationID: string
    readonly id: string
    readonly deleteVulnerabilities: boolean
  }
}

export interface ServersDeleteMutationArgs {
  readonly input?: {
    readonly organizationID: string
    readonly ids: string[]
    readonly deleteVulnerabilities: boolean
  }
}

export const serverDeleteMutationArgs = {
  input: {
    type: new GraphQLInputObjectType({
      name: 'ServerDeleteMutationArgs',
      description:
        'Parameters that describe a delete operation for single server',
      fields: () => ({
        organizationID: {
          description: 'The ID of the organization of the server being deleted',
          type: new GraphQLNonNull(GraphQLID)
        },
        id: {
          description: 'ID of the server being deleted.',
          type: new GraphQLNonNull(GraphQLID)
        },
        deleteVulnerabilities: {
          description:
            'Whether or not to delete the vulnerabilities found on this server.',
          type: new GraphQLNonNull(GraphQLBoolean)
        }
      })
    })
  }
}

export const serversDeleteMutationArgs = {
  input: {
    type: new GraphQLInputObjectType({
      name: 'ServersDeleteMutationArgs',
      description:
        'Parameters that describe a delete operation for multiple servers',
      fields: () => ({
        organizationID: {
          description:
            'The ID of the organization of the servers being deleted',
          type: new GraphQLNonNull(GraphQLID)
        },
        ids: {
          description: 'List of IDs of the servers being deleted.',
          type: new GraphQLNonNull(
            new GraphQLList(new GraphQLNonNull(GraphQLID))
          )
        },
        deleteVulnerabilities: {
          description:
            'Whether or not to delete the vulnerabilities found on the servers.',
          type: new GraphQLNonNull(GraphQLBoolean)
        }
      })
    })
  }
}
